import './Table.css'
import './StickyTable.css'
import './StickyTable-FIX.css'

export * from './TableLegend'
export * from './TableHeader'
export * from './TableCell'
export * from './MinutesTableCell'
export * from './HealthTableCell'
export * from './SpeedTableCell'



// WEBPACK FOOTER //
// src/components/Table/index.js